import React from "react";

import { VisibilityOffRounded, VisibilityRounded } from "@mui/icons-material";
import LoginRoundedIcon from "@mui/icons-material/LoginRounded";
import { Box } from "@mui/material";

import useAuth from "../../../config/context/authContext";
import useModal from "../../../config/context/modalContext";
import { GreyPallet } from "../../../config/styles";
import firebaseError from "../../../config/util/firebaseError";

import MainLinkButton from "../../../components/MainLinkButton";
import MainSolidButton from "../../../components/MainSolidButton";
import MainText from "../../../components/MainText";

import { AvailableFormOptions } from "..";
import MainBorderButton from "../../../components/MainBorderButton";
import { Dev } from "../../../config/util/consoleUtil";
import MainSubmit from "../../../components/MainSubmit";
import TextMain from "../../../components/InputMain/TextMain";

interface ComponentProps {
  setFormOption: (option: AvailableFormOptions) => void;
}

export default function LoginForm({ setFormOption }: ComponentProps) {
  const { authLogInUser } = useAuth();

  const { pushAlert } = useModal();

  const [loading, setLoading] = React.useState(false);

  const [emailField, setEmailField] = React.useState("");
  const [passwordField, setPasswordField] = React.useState("");

  const [showPassword, setShowPassword] = React.useState(false);

  const handleLogin = async () => {
    try {
      setLoading(true);
      await authLogInUser(emailField, passwordField);
    } catch (error) {
      console.log(...new Dev("handleLogin", error).Error());

      pushAlert({
        type: "error",
        message: "Erro ao fazer login. " + firebaseError(error),
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 2 }} style={{ backgroundColor: GreyPallet.Light, borderRadius: 15 }}>
      <MainText color="regular">
        Por segurança, para utilizar todas as funcionalidades do aplicativo é necessário fazer login
        e confirmar o seu email.
      </MainText>

      <Box mt={3}>
        <MainText color="regular">
          Não se procupe, seu email não ficará visível para outros usuários.
        </MainText>
      </Box>

      <Box mt={2}>
        <TextMain
          name="Email"
          value={emailField}
          onChange={setEmailField}
          borderColor={"regular"}
          textColor={"regular"}
          inputType="email"
          inputMode="email"
        />

        <MainSubmit onSubmit={handleLogin}>
          <TextMain
            name="Senha"
            value={passwordField}
            onChange={setPasswordField}
            borderColor={"regular"}
            textColor={"regular"}
            inputType={showPassword ? "text" : "password"}
            adornmentIcon={showPassword ? <VisibilityRounded /> : <VisibilityOffRounded />}
            adornmentClick={() => setShowPassword(!showPassword)}
          />
        </MainSubmit>

        <Box mt={1}>
          <MainSolidButton
            loading={loading}
            text="Fazer Login"
            icon={<LoginRoundedIcon />}
            onClick={handleLogin}
          />
        </Box>
      </Box>

      <Box mt={2}>
        <MainBorderButton
          text="Criar uma conta"
          onClick={() => setFormOption(AvailableFormOptions.signin)}
        />
      </Box>

      <Box mt={2}>
        <MainLinkButton
          text="Esqueci minha senha"
          onClick={() => setFormOption(AvailableFormOptions.reset)}
        />
      </Box>
    </Box>
  );
}
